import React from 'react';

import { flagStyles } from '../settings';

const SvgMU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3648px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMU;
